import { Button, Card, Flex, Result, Typography } from 'antd';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import OnboardingShell from '../../components/OnboardingShell';
import { useCard } from '../../context/CardContext';
import { useOnboarding } from '../../context/OnboardingContext';
import { PaymentOutcome } from '../../types/subscription';
import { buildBotPath } from '../../utils/routes';
import { formatCurrency, formatDateTime, maskCardPan } from '../../utils/format';

const SuccessPage = () => {
    const navigate = useNavigate();
    const { bot_id } = useParams();
    const { state } = useLocation();
    const { subscriptionStatus, activeCard } = useOnboarding();
    const { selectedTariff } = useCard();
    const currentTariff = subscriptionStatus?.tariff || selectedTariff;
    const nextPayment = subscriptionStatus?.next_payment;
    // The charge had not settled yet when the poll gave up. Saying "activated" here would be a
    // guess, so the copy points at the bot instead — that is where the real confirmation arrives.
    const isPending = (state as { paymentOutcome?: PaymentOutcome } | null)?.paymentOutcome === 'pending';

    return (
        <OnboardingShell
            title={isPending ? "To'lov ishlanmoqda" : 'Obuna muvaffaqiyatli ulandi'}
            subtitle={
                isPending
                    ? "Kartangiz ulandi, to'lov tasdiqlanishi kutilmoqda."
                    : "Kartangiz ulanishi va to'lov sozlamalari yakunlandi."
            }
        >
            <Result
                status={isPending ? 'info' : 'success'}
                title={isPending ? "To'lov tekshirilmoqda" : 'Muvaffaqiyatli'}
                subTitle={
                    isPending
                        ? "To'lov tasdiqlangach, kanalga kirish havolasi bot orqali yuboriladi."
                        : 'Tabriklaymiz! Kanalga kirish havolasi bot orqali yuborildi 🥳'
                }
                extra={
                    <Button type="primary" block onClick={() => navigate(buildBotPath(bot_id, '/onboarding/dashboard'))}>
                        Obuna holatini ko'rish
                    </Button>
                }
            />
            <Card className="info-panel" bordered={false}>
                <Flex vertical gap={8}>
                    <Typography.Text className="muted-label">Keyingi yechib olish</Typography.Text>
                    <Typography.Title level={4} className="section-title">
                        {/* `next_payment` is the schedule the cron actually reads; `end_time` is only
                            a fallback, and is null for as long as the subscription is not active. */}
                        {formatDateTime(nextPayment?.pay_time || subscriptionStatus?.end_time)}
                    </Typography.Title>
                    <Typography.Paragraph className="section-text">
                        Miqdor:{' '}
                        {nextPayment
                            ? formatCurrency(nextPayment.amount, nextPayment.currency)
                            : currentTariff
                                ? formatCurrency(currentTariff.amount, currentTariff.currency)
                                : '—'}
                    </Typography.Paragraph>
                    <Typography.Paragraph className="section-text">
                        Faol karta: {activeCard ? maskCardPan(activeCard.pan) : '—'}
                    </Typography.Paragraph>
                </Flex>
            </Card>
        </OnboardingShell>
    );
};

export default SuccessPage;
